import { createPortal } from 'react-dom';
import { Link, useLocation, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { api } from '../api';
import { useShellHeaderExtra } from '../../context/ShellHeaderExtraContext';

export default function Navbar() {
  const location = useLocation();
  const params = useParams();
  const [brand, setBrand] = useState(null);
  const [lead, setLead] = useState(null);
  const headerExtraEl = useShellHeaderExtra();

  useEffect(() => {
    if (params.brandId) {
      api.getBrand(params.brandId).then(setBrand).catch(() => setBrand(null));
    } else {
      setBrand(null);
    }
  }, [params.brandId]);

  useEffect(() => {
    if (params.leadId) {
      api.getLead(params.leadId).then(setLead).catch(() => setLead(null));
    } else {
      setLead(null);
    }
  }, [params.leadId]);

  const isHome = location.pathname === '/lead-quality-score' || location.pathname === '/lead-quality-score/';
  const isBrand = /^\/lead-quality-score\/brands\/[^/]+$/.test(location.pathname);
  const isAddLead = location.pathname.endsWith('/leads/new');
  const isEditLead = location.pathname.includes('/edit');
  const isLeadDetail = params.leadId && !isEditLead;

  // No separate dark bar here anymore, and no brand-logo/wordmark block --
  // the CRM's own DashboardShell already renders RUSH REPUBLIC / Log out
  // one level up. The breadcrumb now portals directly into that same bar
  // (DashboardShell's rr-shell__header-extra slot, to the left of Log out)
  // instead of stacking a second bar underneath it, and renders nothing on
  // Home or before that slot exists in the DOM.
  if (isHome || !headerExtraEl) return null;

  return createPortal(
    // Portaling moves this DOM subtree outside .rr-leadscore-scope (it now
    // lives in DashboardShell's own bar, not inside LeadScoreApp's tree) --
    // CSS descendant selectors like ".rr-leadscore-scope .breadcrumb" need
    // an actual DOM ancestor with that class to match, so re-wrap here to
    // keep leadscore.css's scoped rules (and its CSS custom properties)
    // applying to this portaled content too.
    <div className="rr-leadscore-scope">
    <nav className="breadcrumb">
      <span className="breadcrumb-item" onClick={() => (window.location.href = '/lead-quality-score')}>
        <Link to="/lead-quality-score" style={{ color: 'inherit', textDecoration: 'none' }}>Home</Link>
      </span>

      {params.brandId && (
        <>
          <span className="breadcrumb-sep">›</span>
          <span className={`breadcrumb-item${isBrand ? ' active' : ''}`}>
            <Link to={`/lead-quality-score/brands/${params.brandId}`} style={{ color: 'inherit', textDecoration: 'none' }}>
              {brand?.brand_name || 'Brand'}
            </Link>
          </span>
        </>
      )}

      {isAddLead && (
        <>
          <span className="breadcrumb-sep">›</span>
          <span className="breadcrumb-item active">Add Lead</span>
        </>
      )}

      {isEditLead && (
        <>
          <span className="breadcrumb-sep">›</span>
          <span className="breadcrumb-item active">Edit Lead</span>
        </>
      )}

      {isLeadDetail && (
        <>
          <span className="breadcrumb-sep">›</span>
          <span className="breadcrumb-item active">{lead?.full_name || 'Lead Detail'}</span>
        </>
      )}
    </nav>
    </div>,
    headerExtraEl,
  );
}
